// import { timingSafeEqual } from "crypto";

export class Staff {
    constructor(staff) {
        this.user_id    = staff.user_id;
        this.name       = staff.name;
        this.code       = staff.code;
        this.created_at = staff.created_at;
        this.updated_at = staff.updated_at;
        this.color_code = (staff.color_code && staff.color_code != null) ? staff.color_code : '#2979FF';
        this.status     = staff.status;
        this.image_url  = staff.image_url;
        this.delete_image_url = staff.delete_image_url;
        this.booking_active = staff.booking_active;
        this.commission_type = staff.commission_type;
        this.email = staff.email;
        this.phone = staff.phone;
        this.address = staff.address;
        this.nickname = staff.nickname;
        this.permission = staff.permission;
    }
}
